import { useMemo } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { candidateVerifySignup } from '../../utils/candidateApi';
import SetPasswordForm from '../_shared/SetPasswordForm';

/**
 * Completes candidate signup from the emailed one-time link.
 * Route: /candidate/verify-signup?token=… (matches the URL the server emails).
 */
export default function CandidateVerifySignup() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  if (!token || token.length < 32) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-8">
        <div className="surface-elevated p-8 max-w-md w-full text-center">
          <h1 className="text-lg font-semibold text-slate-900">Invalid or missing link</h1>
          <p className="text-sm text-slate-500 mt-2">
            Open the full link from your sign-up email, or start again to get a new one.
          </p>
          <Link to="/candidate/signup" className="inline-block mt-6 text-brand-600 hover:underline text-sm">
            Request a new sign-up link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="surface-elevated p-8">
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Finish your account</h2>
          <p className="text-sm text-slate-500 mb-6">
            Choose a password to activate your candidate portal account.
          </p>
          <SetPasswordForm
            token={token}
            submit={candidateVerifySignup}
            tokenKind="verification"
            submitLabel="Create account"
            successMessage="Account ready. Welcome!"
            onSuccess={(data) => {
              // candidateVerifySignup() already stored the token in memory.
              navigate(data?.accessToken ? '/portal' : '/candidate/login', { replace: true });
            }}
            recovery={
              <Link to="/candidate/signup" className="font-medium text-danger-800 underline hover:text-danger-900">
                Request a new sign-up link
              </Link>
            }
          />
        </div>
        <p className="text-center text-slate-500 text-sm mt-6">
          <Link to="/candidate/login" className="text-brand-600 hover:underline">Back to candidate sign in</Link>
        </p>
      </div>
    </div>
  );
}
